import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a Turkish phone number with +90 prefix for tel: links
 * @param phone - The phone number to format
 * @returns The phone number with +90 prefix
 */
export function formatTurkishPhoneForCall(phone: string): string {
  if (!phone) return '';
  
  // Remove any existing country code and formatting
  const cleanPhone = phone.replace(/[\s\-\(\)\+]/g, '').replace(/^90/, '');
  
  // Add +90 prefix for Turkish numbers
  return `+90${cleanPhone}`;
}

/**
 * Formats a Turkish phone number for database storage
 * Converts formats like "05464337247" to "905464337247"
 * @param phone - The phone number to format
 * @returns The phone number in format "90XXXXXXXXX" (without leading 0, with 90 prefix)
 */
export function formatTurkishPhoneForDatabase(phone: string | null | undefined): string | null {
  if (!phone) return null;
  
  // Remove all spaces, dashes, and parentheses (but keep + for now to check for +90)
  let cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
  
  // If empty after cleaning, return null
  if (!cleanPhone) return null;
  
  // Check for +90 prefix first (before removing +)
  if (cleanPhone.startsWith('+90')) {
    cleanPhone = '90' + cleanPhone.substring(3);
  }
  // Remove any remaining + signs
  else if (cleanPhone.startsWith('+')) {
    cleanPhone = cleanPhone.substring(1);
  }
  
  // Now handle the cleaned phone number
  // If starts with 0, remove it and add 90
  if (cleanPhone.startsWith('0')) {
    cleanPhone = '90' + cleanPhone.substring(1);
  }
  // If already starts with 90, keep as is
  else if (!cleanPhone.startsWith('90')) {
    // If it doesn't start with 90 or 0, assume it's a local number and add 90
    cleanPhone = '90' + cleanPhone;
  }
  
  return cleanPhone;
}